module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-group information-group"
  }, [_c('div', {
    staticClass: "panel panel-info info-panel"
  }, [_c('div', {
    staticClass: "panel-heading header text-center"
  }, [_vm._v(" Instructions ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ol', {
    staticClass: "instructions"
  }, [_c('li', [_vm._v("Set your ZIP Code to the the location of the images you will be uploading.")]), _vm._v(" "), _c('li', [_vm._v("Click on the "), _c('i', [_vm._v("\"Select Files\"")]), _vm._v(" button to open up your file directory. \n            From there, select every picture you want analyzed. \n            \n        ")]), _vm._v(" "), _c('li', [_vm._v("Hit the "), _c('i', [_vm._v("\"Submit\"")]), _vm._v(" button. Everything will be processed and the progress bar will keep\n            you updated on the status of the analysis!\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-spacer"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading header text-center"
  }, [_vm._v(" Additional Information ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body additional-information"
  }, [_c('ul', [_c('li', [_c('i', [_vm._v("Helpful Tip:")]), _vm._v(" ctrl + click selects a new file while keeping the previous files selected.\n                                You can also use shift + click as a powerfully similar selection tool.\n        ")]), _vm._v(" "), _c('li', [_vm._v("Expect longer wait times the more files you choose to upload.")]), _vm._v(" "), _c('li', [_vm._v("In very rare circumstances, the zip code you provide may not work. \n            Use a different ZIP!\n        ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f5b83e26!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 376
// module chunks = 2